const GET_INVOICE_SHOPS = "GET_INVOICE_SHOPS";
const GET_INVOICE_SHOPS_SUCCESS = "GET_INVOICE_SHOPS_SUCCESS";
const GET_INVOICE_SHOPS_FAILURE = "GET_INVOICE_SHOPS_FAILURE";
const CLEAR_GET_INVOICE_SHOPS = "CLEAR_GET_INVOICE_SHOPS";
const GetInvoiceShopsSymbols = {
  GET_INVOICE_SHOPS_SUCCESS,
  GET_INVOICE_SHOPS_FAILURE,
  GET_INVOICE_SHOPS,
  CLEAR_GET_INVOICE_SHOPS,
};
export default GetInvoiceShopsSymbols;
